import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

const messages = defineMessages<SortOrder>({
  [SortOrder.ASC]: {
    id: "map.layer.userLocation.asc",
    defaultMessage: "Newest first",
    description: "Newest first location history sort",
  },
  [SortOrder.DESC]: {
    id: "map.layer.userLocation.desc",
    defaultMessage: "Oldest first",
    description: "Oldest first location history sort",
  },
});

const getSortDirectionLabel = (intl: IntlShape, order: SortOrder): string =>
  intl.formatMessage(messages[order]);
export default getSortDirectionLabel;
